module.exports = __webpack_public_path__ + "img/taxi-bus.e6b98919.svg";